
import Vue from 'vue'
import { achost } from '@/store/constants';

let showProfaneErr = false;
export function createFormErrors(field) {
    const errors = [];
    if (!field.$dirty) return errors;

    if (showProfaneErr === true) {
        errors.push(`Contains text some people might find offensive.`);
    }

    if (field.$params.required && field.$model === ""){
        errors.push("This field is required")
    }

    for (const prop in field) {
        console.log(field)
        console.log(prop)
        if (field[prop] === false) {
            switch (prop) {
                case "invalidCharacters":
                    errors.push(`Contains invalid characters.`);
                    break;           
                case "maxLength":
                    errors.push(`Must be at most ${field.$params[prop].max} characters`);
                    break;
                case "minLength":
                    errors.push(`Must be at least ${field.$params[prop].min} caracters`);
                    break;
                case "email":
                    errors.push(`Must be a valid email address`);
                    break;
                case "sameAs":
                    errors.push(`Must be same as ${field.$params[prop].eq}`);
                    break;
            }
        }
    }
    return errors;
}

export function invalidCharacters(value) {
    if (value === '') return true;
    if (value.length < 4) return true;
    return /^[a-zA-Z0-9_]*$/.test(value);
}

// https://apex-connect.avalanchestudios.com/api/v1/abuse/profane/${value}
// ${achost}/api/v1/abuse/profane/${value}
export function isProfane(value) {
    if(value.length >= 4) {
        return Vue.axios.get(`${achost}/api/v1/abuse/profane/${value}`).then((resp) => {
            showProfaneErr = resp.data.is_profane
            return !resp.data.is_profane;
        }).catch(() => {
            return;
        })
    } else {
        return false;
    }
}